import { apiClient } from '../client';

export interface GetUserParams {
  component_id: number;
  name: string;
  tenant_id?: number;
  target_tenant_id?: number;
  profile_status: string;
  size: number;
  page: number;
  branches_ids: string;
  id: string;
  city_id?:string;
  userGroup_id?:string;
  // Add sorting parameter
  sort?: string; // Format: "column,direction" e.g., "name,asc" or "createdAt,desc"
}

export interface GetUserGroupParams {
  component_id: number;
  tenant_id?: number;
  target_component_id: number;
  target_tenant_id: number;
}

export interface UserResponse {
  // Add response type based on your API response structure
  [key: string]: any;
}

export interface UserGroupResponse {
  // Add response type based on your API response structure
  [key: string]: any;
}

/**
 * Get user information by component_id, name, and tenant_id
 * @param params - The query parameters
 */
export const getUsers = async (params: GetUserParams): Promise<UserResponse> => {
  const response = await apiClient.get("/account/v3/user", {
    params: params,
  });
  const total = parseInt(response.headers["x-total-count"] || "0", 10);

  return {
    total: total,
    data: response.data
  };
};

export const getUserGroups = async (params: GetUserGroupParams): Promise<UserGroupResponse> => {
  const response = await apiClient.get("/account/v3/user-group", {
    params: params,
  });

  return {
    data: response.data
  };
};
